(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["col-4-square-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopMedia = window.matchMedia('(min-width: 1000px)');

    function initializeSection(section) {
      const swiperContainer = section.querySelector('[data-square-carousel]');
      if (!swiperContainer) return;

      const mobileLayout = swiperContainer.closest('[data-square-carousel-section]').dataset.mobileLayout;
      if (mobileLayout === 'grid' && !desktopMedia.matches) {
        if (swiperContainer.swiper) {
          swiperContainer.squareActiveIndex = swiperContainer.swiper.activeIndex;
          swiperContainer.swiper.destroy(true, true);
        }
        return;
      }
      if (swiperContainer.swiper || typeof Swiper === 'undefined') return;

      const prevBtn = section.querySelector('.square-nav-btn.prev-btn');
      const nextBtn = section.querySelector('.square-nav-btn.next-btn');
      const wrapperEl = section.querySelector('.square-carousel-wrapper');
      const navEl = section.querySelector('.square-nav');
      const firstImage = section.querySelector('.square-image-wrapper');

      function positionNavBtns() {
        if (!wrapperEl || !firstImage || !navEl) return;

        const wrapperRect = wrapperEl.getBoundingClientRect();
        const imageRect = firstImage.getBoundingClientRect();
        navEl.style.top = `${imageRect.top - wrapperRect.top + imageRect.height / 2}px`;
      }

      const imageEvents = new AbortController();
      swiperContainer.squareImageEvents = imageEvents;
      let navFrame = null;

      const scheduleNavPosition = () => {
        if (imageEvents.signal.aborted || navFrame !== null) return;
        navFrame = requestAnimationFrame(() => {
          navFrame = null;
          if (!imageEvents.signal.aborted) positionNavBtns();
        });
      };

      new Swiper(swiperContainer, {
        initialSlide: swiperContainer.squareActiveIndex || 0,
        spaceBetween: 9,
        slidesPerView: 2,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'swiper-button-disabled'
        },
        on: {
          init: scheduleNavPosition,
          slideChangeTransitionEnd: scheduleNavPosition,
          resize: scheduleNavPosition,
          beforeDestroy: () => {
            imageEvents.abort();
            if (navFrame !== null) cancelAnimationFrame(navFrame);
            navFrame = null;
            if (swiperContainer.squareImageEvents === imageEvents) {
              delete swiperContainer.squareImageEvents;
            }
          }
        },
        breakpoints: {
          1000: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        }
      });

      section.querySelectorAll('.square-image-wrapper img').forEach((img) => {
        if (img.complete) return;
        const onSettled = () => {
          img.removeEventListener('load', onSettled);
          img.removeEventListener('error', onSettled);
          scheduleNavPosition();
        };
        img.addEventListener('load', onSettled, { signal: imageEvents.signal });
        img.addEventListener('error', onSettled, { signal: imageEvents.signal });
      });
    }

    function initializeAll() {
      document.querySelectorAll('[data-square-carousel-section]').forEach(initializeSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    desktopMedia.addEventListener('change', initializeAll);

    document.addEventListener('shopify:section:load', (event) => {
      initializeSection(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelector('[data-square-carousel]')?.swiper?.destroy(true, true);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('.square-slide');
      const swiper = slide?.closest('[data-square-carousel]')?.swiper;
      if (!swiper) return;

      swiper.slideTo(Array.from(swiper.slides).indexOf(slide), 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features-col2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-features-col2')) {
    customElements.define('product-features-col2', class ProductFeaturesCol2 extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const initialize = () => this.initializeSwiper();

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          this.features_swiper?.slideTo(Number(tab.dataset.tabIndex));
        }, options);

        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          let index = tabs.indexOf(tab);
          if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else return;
          event.preventDefault();
          tabs[index].focus({ preventScroll: true });
          this.features_swiper?.slideTo(index);
        }, options);

        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.swiper-slide');
          if (!slide || !this.contains(slide)) return;
          this.initializeSwiper();
          const index = Array.from(this.querySelectorAll('.swiper-slide')).indexOf(slide);
          this.features_swiper?.slideTo(index, 0);
        }, options);

        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.contains(this)) this.initializeSwiper();
        }, options);

        document.addEventListener('shopify:section:reorder', (event) => {
          if (event.target.contains(this)) this.features_swiper?.update();
        }, options);

        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(this)) this.destroySwiper();
        }, options);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { ...options, once: true });
        }
        window.addEventListener('load', initialize, { ...options, once: true });
        this.initFrame = requestAnimationFrame(initialize);
      }

      disconnectedCallback() {
        this.events?.abort();
        cancelAnimationFrame(this.initFrame);
        this.destroySwiper();
      }

      initializeSwiper() {
        if (!this.isConnected || this.features_swiper || typeof Swiper === 'undefined') return;
        const container = this.querySelector('.bottom-wrapper');
        if (!container || !container.querySelector('.swiper-slide')) return;

        this.features_swiper = new Swiper(container, {
          initialSlide: this.activeIndex || 0,
          spaceBetween: 10,
          slidesPerView: 1,
          autoHeight: true,
          a11y: false,
          navigation: {
            prevEl: this.querySelector('.prev_button'),
            nextEl: this.querySelector('.next_button')
          },
          on: {
            init: (swiper) => {
              this.updateTabs(swiper);
              this.scheduleHeightUpdate();
            },
            slideChange: (swiper) => this.updateTabs(swiper),
            slideChangeTransitionEnd: () => this.scheduleHeightUpdate(),
            resize: () => this.scheduleHeightUpdate()
          }
        });

        this.querySelectorAll('.bottom-wrapper img').forEach((image) => {
          if (image.complete) return;
          const onSettled = () => {
            image.removeEventListener('load', onSettled);
            image.removeEventListener('error', onSettled);
            this.scheduleHeightUpdate();
          };
          image.addEventListener('load', onSettled, { signal: this.events.signal });
          image.addEventListener('error', onSettled, { signal: this.events.signal });
        });
        this.scheduleHeightUpdate();
      }

      updateTabs(swiper) {
        this.activeIndex = swiper.activeIndex;
        this.querySelectorAll('[role="tab"]').forEach((tab, index) => {
          const active = index === swiper.activeIndex;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.querySelectorAll('.swiper-slide').forEach((slide, index) => {
          const active = index === swiper.activeIndex;
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          slide.tabIndex = active ? 0 : -1;
        });
      }

      scheduleHeightUpdate() {
        if (this.heightFrame != null) return;
        this.heightFrame = requestAnimationFrame(() => {
          this.heightFrame = null;
          if (this.isConnected && this.features_swiper && !this.features_swiper.destroyed) {
            this.features_swiper.updateAutoHeight(0);
          }
        });
      }

      destroySwiper() {
        cancelAnimationFrame(this.heightFrame);
        this.heightFrame = null;
        if (this.features_swiper) {
          this.activeIndex = this.features_swiper.activeIndex;
          this.features_swiper.destroy(true, true);
          this.features_swiper = null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
